@if (relatedContactsDetails$ | async; as relatedContactDetails) {
  <div
    class="card-list p-3"
    >
    @for (item of relatedContactDetails; track item) {
      <div class="card-col">
        <div class="card data-card h-100">
          <div class="card-body">
            <div class="card-left pe-2">
              @if (
                item['isEmployee'] && (this.currentAvatar$ | async); as avatar
                ) {
                <img
              src="{{ avatar.url }}?name={{ item['name'] }}&bgColor={{
                avatar.bgColor
              }}&color=FFFFFF"
                  class="card-img"
                  />
                }
                @if (!item['isEmployee'] && item['isCompany']) {
                  <img
                    class="card-img"
                    src="../../../../assets/images/avatar_company.svg"
                    />
                }
                @if (!item['isEmployee'] && !item['isCompany']) {
                  <img
                    class="card-img"
                    src="../../../../assets/images/user.svg"
                    />
                }
              </div>
              <div class="card-content">
                @if (item['name']) {
                  <h5 class="card-title">
                    {{ item["parentName"] }}, {{ item["name"] }}
                  </h5>
                }
                <!--            <h5 class="card-title" *ngIf="!item['name']"> {{ item['id'] }} </h5>-->
                @if (item['city'] && item['zipCode']) {
                  <span
                    class="card-subtitle text-muted mb-1"
                    >
                    <i class="mdi mdi-map-marker me-1"></i>
                    {{ item["zipCode"] }} {{ item["city"] }}
                  </span>
                }
                @if (item['email']) {
                  <span class="card-subtitle text-muted mb-1">
                    <i class="mdi mdi-email me-1"></i>
                    {{ item["email"] }}
                  </span>
                }
              </div>
            </div>
            <a
              (click)="onCardClick(item['id'].toString())"
              class="stretched-link"
            ></a>
          </div>
        </div>
      }
    </div>
  }
